export enum CampaignStatus {
  Draft = "draft",
  Scheduled = "scheduled",
  Delivered = "delivered",
}
